/**
 *               ! ВАЖНО !
 * Когда добавляешь новые шаги или ошибки,
 * не забудь обновить массив stepsWithoutInitialData в папке constants,
 * он нужен чтобы не запрашивать данные на ноде, когда основные шаги лендинга не отображаются
 **/
export enum EJoinOtaStep {
  Authorization = 'authorization',

  UserData = 'userData',
  Insurance = 'insurance',
  Success = 'success',

  Error = 'error',
  ErrorSubAccount = 'errorSubAccount',
  ErrorBnovo = 'errorBnovo',
  ErrorRegion = 'errorRegion',
  ErrorOffersOtaValidation = 'errorOffersOtaValidation',
  ErrorAlreadyAcceptedPublicOffer = 'errorAlreadyAcceptedPublicOffer',
  ErrorDoesNotHaveOffers = 'errorDoesNotHaveOffers',

  Unexpected = 'unexpected',
}
